<template>
  <div>
    <div class="d-flex justify-center mb-9">
      <v-card class="w-100" flat>
        <div v-show="stepOne">
          <div class="d-flex justify-space-between align-center">
            <div class="h1">ADD EXAM PAYMENT</div>
            <v-icon @click="close">mdi-close</v-icon>
          </div>
          <div class="mb-4 mt-3">
            <b
              >Status for {{ GetPreviewUser.FirstName }}
              {{ GetPreviewUser.LastName }}</b
            >
          </div>
          <div>
            <v-row no-gutters>
              <v-col cols="3">Member Level:</v-col>
              <v-col cols="9">
                <b> {{ getMembershipByUserId.Name }}</b></v-col
              >
            </v-row>
            <v-row no-gutters>
              <v-col cols="3">Exams:</v-col>
              <v-col cols="9">
                <b> {{ examName }} </b></v-col
              >
            </v-row>
            <v-row no-gutters>
              <v-col cols="3">Credentials:</v-col>
              <v-col cols="9">
                <b> {{ credentialName }} </b></v-col
              >
            </v-row>
            <v-row no-gutters>
              <v-col cols="3">Renewal Date:</v-col>
              <v-col cols="9">
                <b> {{ getDate }} </b></v-col
              >
            </v-row>
          </div>
          <v-divider class="divider"></v-divider>
          <v-row class="mt-6">
            <v-row>
              <v-col cols="12" md="5"
                ><div class="d-flex justify-end">
                  <b class="font-18">Exam Type:</b>
                </div></v-col
              >
              <v-col cols="12" md="7">
                <v-autocomplete
                  :items="ExamTypeList"
                  label="Exam Type"
                  attach
                  v-model="paymentForm.Exam"
                  :menu-props="{ maxHeight: '230' }"
                  item-text="name"
                  item-value="id"
                  dense
                  outlined
                  single-line
                  @change="getNameAndPrice(paymentForm.Exam)"
                  :error-messages="
                    $v.paymentForm.Exam.$error ? 'Exam Type is required' : null
                  "
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-row>

          <v-row>
            <v-col cols="12" md="5"
              ><div class="d-flex justify-end">
                <b class="font-18">Payment Option:</b>
              </div></v-col
            >
            <v-col cols="12" md="7">
              <v-radio-group v-model="PaymentOption" class="pa-0 ma-0">
                <v-radio value="online">
                  <template v-slot:label>
                    <div class="mt-1">ONLINE (Process Credit Card)</div>
                  </template>
                </v-radio>
                <v-radio value="offline" class="">
                  <template v-slot:label>
                    <div class="mt-1">
                      OFFLINE (Generate record/invoice/email without payment)
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </div>
        <div v-show="stepTwo">
          <div class="px-4">
            <div class="d-flex justify-space-between align-center">
              <div class="h1">Online Payment</div>
              <v-icon @click="close">mdi-close</v-icon>
            </div>
            <div class="mb-4 mt-3">
              <b>Payment Information </b>
            </div>
            <div>
              <v-row no-gutters>
                <v-col cols="3">User:</v-col>
                <v-col cols="9">
                  <b>
                    {{ GetPreviewUser.FirstName }}
                    {{ GetPreviewUser.LastName }}</b
                  ></v-col
                >
              </v-row>
              <v-row no-gutters>
                <v-col cols="3">Payment for:</v-col>
                <v-col cols="9">
                  <b> {{ exmaData && exmaData.name }} </b></v-col
                >
              </v-row>
              <v-row no-gutters>
                <v-col cols="3">Fee:</v-col>
                <v-col cols="9">
                  <b>${{ exmaData && exmaData.price }} USD</b></v-col
                >
              </v-row>
            </div>
            <!-- <v-divider class="divider"></v-divider> -->
          </div>
          <!-- <div class="font-18 my-8 px-4 d-flex justify-space-between">
            <b>Billing Address</b>
          </div> -->
          <!-- <div class="px-4">
            <v-row class="mt-4">
              <v-col cols="12" md="6">
                <p><b> First Name</b></p>
                <v-text-field
                  single-line
                  outlined
                  flat
                  solo
                  dense
                  v-model="paymentForm.BillingDetails.FirstName"
                  :error-messages="getErrorMessage('FirstName', 'FirstName')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <p><b>Last Name</b></p>
                <v-text-field
                  single-line
                  outlined
                  flat
                  solo
                  dense
                  v-model="paymentForm.BillingDetails.LastName"
                  :error-messages="getErrorMessage('LastName', 'LastName')"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <p><b>Street Address</b></p>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  outlined
                  flat
                  dense
                  single-line
                  append-icon="mdi-check"
                  v-model="paymentForm.BillingDetails.StreetAddress1"
                  :error-messages="
                    getErrorMessage('StreetAddress1', 'StreetAddress1')
                  "
                >
                </v-text-field
              ></v-col>
              <v-col cols="6"
                ><v-text-field
                  v-model="paymentForm.BillingDetails.StreetAddress2"
                  outlined
                  flat
                  dense
                  single-line
                  append-icon="mdi-check"
                  :error-messages="
                    getErrorMessage('StreetAddress2', 'StreetAddress2')
                  "
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row class="my-0 py-0">
              <v-col cols="12" md="6">
                <p><b> City</b></p>
                <v-text-field
                  single-line
                  outlined
                  flat
                  solo
                  dense
                  v-model="paymentForm.BillingDetails.City"
                  :error-messages="getErrorMessage('City', 'City')"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <p><b>State / Province / Region</b></p>
                <v-text-field
                  single-line
                  outlined
                  flat
                  solo
                  dense
                  v-model="paymentForm.BillingDetails.Province"
                  :error-messages="getErrorMessage('Province', 'Province')"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <p><b> Zip Code</b></p>
                <v-text-field
                  single-line
                  outlined
                  flat
                  solo
                  dense
                  v-model="paymentForm.BillingDetails.ZipCode"
                  :error-messages="getErrorMessage('ZipCode', 'ZipCode')"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <p><b>Country / Region</b></p>
                <v-text-field
                  single-line
                  outlined
                  flat
                  solo
                  dense
                  v-model="paymentForm.BillingDetails.Country"
                  :error-messages="getErrorMessage('Country', 'Country')"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <div class="mt-8"><b>Phone Number</b></div>
            <v-text-field
              single-line
              outlined
              class="mt-5"
              flat
              solo
              dense
              maxlength="17"
              minlength="7"
              v-model="paymentForm.BillingDetails.PhoneNumber"
              :error-messages="getErrorMessage('PhoneNumber', 'PhoneNumber')"
            >
              >
            </v-text-field>
          </div> -->

          <!-- <v-divider class="divider mt-9"></v-divider> -->
          <!-- <div class="font-18 my-8 px-4">
            <b>Credit Card Information</b>
          </div> -->
          <v-card outlined class="mt-7 mx-4 pb-2 pt-4 px-4">
            <p><b>Name on Card</b></p>
            <v-text-field
              dense
              label="Card Holder Name"
              single-line
              outlined
              v-model="paymentForm.PaymentCard.CardHolderName"
              :error-messages="
                getErrorMessagePayment('CardHolderName', 'CardHolderName')
              "
            ></v-text-field>

            <p><b>Card Number</b></p>
            <v-text-field
              label="Card Number"
              v-model="paymentForm.PaymentCard.CardNumber"
              dense
              outlined
              single-line
              maxlength="16"
              :error-messages="
                getErrorMessagePayment('CardNumber', 'CardNumber')
              "
            ></v-text-field>

            <div class="d-flex justify-between gap-3">
              <div style="flex-basis: 50%; width: 50%">
                <p><b>Expiration Date</b></p>
                <v-text-field
                  v-model="paymentForm.PaymentCard.CardExp"
                  class=""
                  label="MM/YY"
                  maxlength="5"
                  dense
                  outlined
                  single-line
                  @input="formatExpiryDate"
                  :error-messages="getErrorMessagePayment('CardExp', 'CardExp')"
                ></v-text-field>
              </div>

              <div style="flex-basis: 50%; width: 50%">
                <p><b>CVV</b></p>
                <v-text-field
                  class=""
                  v-model="paymentForm.PaymentCard.CardCVV"
                  label="CVV"
                  dense
                  outlined
                  :maxlength="paymentForm.PaymentCard.CardNumber?.length === 15 ? 4 : 3"
                  single-line
                  :error-messages="getErrorCardNumberCvv(paymentForm.PaymentCard.CardCVV)"
                ></v-text-field>
              </div>
            </div>
          </v-card>
          <!-- <div>
            <v-row>
              <v-col class="py-1">
                <v-row>
                  <v-col cols="3">
                    <div class="mr-3 d-flex align-center">Name on Card</div>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field outlined hide-details dense></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="my-7">
              <v-col class="py-1">
                <v-row>
                  <v-col cols="3">
                    <div class="mr-3 d-flex align-center">Card Number:</div>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field outlined hide-details dense></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="py-1">
                <v-row>
                  <v-col cols="3">
                    <div class="mr-3 d-flex align-center">CVV Code:</div>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field outlined hide-details dense></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-1">
                <v-row>
                  <v-col cols="3">
                    <div class="mr-3 d-flex align-center">Expiration Date:</div>
                  </v-col>
                  <v-col cols="9">
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      attach
                      :nudge-top="300"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="date"
                          label="Picker in menu"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          hide-details
                          dense
                          outlined
                          single-line
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="date" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu = false">
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu.save(date)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="py-1"> </v-col>
            </v-row>
          </div> -->
        </div>
        <div class="d-flex justify-space-between mt-11 px-4">
          <div>
            <v-btn
              color="primary"
              class="px-9"
              v-show="this.stepTwo == true"
              @click="GoBack()"
              >Back</v-btn
            >
          </div>
          <div>
            <v-btn
              color="primary"
              class="px-9"
              v-if="this.PaymentOption === 'offline' || this.stepTwo == true"
              :disabled="btnloader"
              @click="Submit()"
            >
              <span v-if="btnloader != true">Submit</span>
              <v-progress-circular
                indeterminate
                size="20"
                class="px-5"
                color="white"
                v-show="btnloader"
              ></v-progress-circular
            ></v-btn>
            <v-btn
              color="primary"
              class="px-9"
              v-if="this.PaymentOption === 'online'"
              v-show="this.stepTwo == false"
              @click="GoToStepTwo()"
              >Next
            </v-btn>
          </div>
        </div>
      </v-card>
    </div>
    <v-dialog v-model="OfflineSuccessfullDialog" persistent max-width="400">
      <v-card class="pa-5 pb-8">
        <div class="d-flex justify-end">
          <v-icon @click="closeOfflineSuccessfullDialog()">mdi-close</v-icon>
        </div>
        <div v-if="this.PaymentOption === 'offline'">
          <div
            class="d-flex justify-center"
            style="font-size: 2rem; color: rgb(63, 72, 204); font-weight: bold"
          >
            Success
          </div>
          <div class="d-flex justify-center mt-5" style="font-size: 1.3rem">
            Your offline payment has been <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            processed. A record of this <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            transaction and an invoice will <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            be recorded in this User's <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            account. An email of the <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            transaction details will be sent <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            to the User.
          </div>
        </div>
        <div v-else>
          <div
            class="d-flex justify-center"
            style="font-size: 2rem; color: rgb(63, 72, 204); font-weight: bold"
          >
            Success
          </div>
          <div class="d-flex justify-center mt-5" style="font-size: 1.3rem">
            Your payment has been <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            processed. A record of this <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            transaction and an invoice will <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            be recorded in this User's <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            account. An email of the <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            transaction details will be sent <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            to the User.
          </div>
        </div>
      </v-card></v-dialog
    >
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  required,
  // email,
  // alpha,
  numeric,
  minLength,
  // maxLength,
} from "vuelidate/lib/validators";
const alphaWithSpacesAndSpecialChars = (value) => {
  if (!value) return true;
  // return /^[A-Za-z\s]+$/.test(value);    //to allow spaces
  // return /^[A-Za-z\s!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+$/.test(value); //to allow spaces and special characters

  return /^[A-Za-z\s!@#$%^&*()_+\-=[\]{};'’:"\\|,.<>/?áàãâäåāăąçćĉċčðďèéêëēĕėęěĝğġģĥħìíîïĩīĭįıĵķĺļľłńņňŋòóôõöøōŏőœñŕŗřśŝşšţťŧùúûüũūŭůűųŵýÿŷźżžÁÀÃÂÄÅĀĂĄÇĆĈĊČÐĎÈÉÊËĒĔĖĘĚĜĞĠĢĤĦÌÍÎÏĨĪĬĮİĴĶĹĻĽŁŃŅŇŊÒÓÔÕÖØŌŎŐŒŔŖŘŚŜŞŠŢŤŦÙÚÛÜŨŪŬŮŰŲŴÝŸŶŹŻŽ\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FFF]+$/.test(value);
  // to allow spaces, special char, latin char. Japanese characters (Kanji, Hiragana and Katakana scripts)
};
const allowDigitsAndSteric = (value) => {
  if (!value) return true;
  return /^[0-9*]+$/.test(value); // to allow digits and *
};
export default {
  props: ["ExamCredentialPaymentProcess", "examName", "credentialName"],
  name: "ExamCredentialPaymentComponent",
  computed: {
    ...mapGetters(["GetPreviewUser", "getMembershipByUserId"]),
    getDate() {
      const date = new Date(this.getMembershipByUserId.EndDateTime);
      const options = { month: "long", day: "numeric", year: "numeric" };
      return date.toLocaleDateString("en-US", options);
    },
  },
  data() {
    return {
      isFormSubmitted: false,
      btnloader: false,
      OfflineSuccessfullDialog: false,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      PaymentFor: [],
      PaymentOption: "",
      PaymentInformationFee: [],
      stepOne: true,
      stepTwo: false,
      ExamTypeList: [
        { name: "CBP Exam - $50 USD", id: 1, price: 50 },
        { name: "CBP-A Exam - $50 USD", id: 2, price: 50 },
        { name: "AdvCBP 4(7) & 9 Exam Type - $100", id: 3, price: 100 },
        { name: "AdvCBP 3 & 6 Exam Type - $100", id: 4, price: 100 },
        { name: "PaRama Exam - $100", id: 5, price: 100 },
      ],
      exmaData: null,
      examType: null,
      paymentForm: {
        Exam: null,
        UserId: 0,
        // BillingDetails: {
        //   FirstName: "",
        //   LastName: "",
        //   StreetAddress1: "",
        //   StreetAddress2: "",
        //   City: "",
        //   Province: "",
        //   ZipCode: "",
        //   Country: "",
        //   PhoneNumber: "",
        // },
        PaymentCard: {
          UserId:0,
          PaymentCardId: 0,
          PaymentType: 1,
          CardHolderName: "",
          CardNumber: "",
          CardExp: "",
          CardCVV: "",
        },
        IsOnlinePayment: true,
        PaidAmount: 0,
      },
    };
  },
  validations: {
    paymentForm: {
      Exam: {
        required,
      },
      // BillingDetails: {
      //   FirstName: { required, alpha },
      //   LastName: { required, alpha },
      //   StreetAddress1: { required },
      //   StreetAddress2: { required },
      //   Province: { required },
      //   City: { required },
      //   Country: { required },
      //   ZipCode: { required },
      //   PhoneNumber: {
      //     required,
      //     numeric,
      //     minLength: minLength(7),
      //     maxLength: maxLength(17),
      //   },
      // },
      PaymentCard: {
        CardHolderName: { required, alphaWithSpacesAndSpecialChars },
        CardNumber: {
          required,
          numeric,
          minLength: minLength(15),
        },
        CardExp: {
          required,
          expiryDate(value) {
            const [month, year] = value.split("/");
            const currentDate = new Date();
            const currentYear = currentDate.getFullYear() % 100;
            const currentMonth = currentDate.getMonth() + 1;

            if (
              parseInt(month) >= 1 &&
              parseInt(month) <= 12 &&
              parseInt(year) >= currentYear &&
              ((parseInt(year) === currentYear &&
                parseInt(month) >= currentMonth) ||
                parseInt(year) > currentYear)
            ) {
              return true;
            } else {
              return false;
            }
          },
        },
        CardCVV: { required, allowDigitsAndSteric: allowDigitsAndSteric, minLength: minLength(3) },
      },
    },
  },
  methods: {
    formatExpiryDate() {
      if (
        this.paymentForm.PaymentCard.CardExp.length === 2 &&
        !this.paymentForm.PaymentCard.CardExp.includes("/")
      ) {
        this.paymentForm.PaymentCard.CardExp += "/";
      }
    },
    // getErrorMessage(fieldName) {
    //   const errorMessages = {
    //     FirstName: {
    //       required: "First Name is required",
    //       alpha: "First Name only contains alphabetic characters.",
    //     },
    //     LastName: {
    //       required: "Last Name is required",
    //       alpha: "Last Name only contains alphabetic characters.",
    //     },
    //     StreetAddress1: {
    //       required: "Street Address is required",
    //     },
    //     StreetAddress2: {
    //       required: "Street Address is required",
    //     },
    //     City: {
    //       required: "City is required",
    //     },
    //     ZipCode: {
    //       required: "Zip Code is required",
    //     },
    //     Country: {
    //       required: "Country is required",
    //     },
    //     Province: {
    //       required: "Province is required",
    //     },
    //     PhoneNumber: {
    //       required: "Phone number is required",
    //       numeric: "Phone number should be only numeric characters",
    //       minLength: "Phone number should be minimum of 7 digits",
    //     },
    //   };
    //   const errorField = this.$v.paymentForm.BillingDetails[fieldName];
    //   if (!errorField.$dirty) return null;
    //   const errors = [];
    //   Object.keys(errorField.$params).forEach((param) => {
    //     if (!errorField[param]) {
    //       errors.push(errorMessages[fieldName][param]);
    //     }
    //   });
    //   return errors.length ? errors[0] : null;
    // },
    getErrorMessagePayment(fieldName) {
      const errorMessages = {
        CardHolderName: {
          required: "Cardholder name is required",
          alphaWithSpacesAndSpecialChars: "Only alphabetical characters are allowed."
        },
        CardNumber: {
          required: "Card Number is required",
          minLength: "Minimum of 15 digits is required",
          numeric: "Alphabetic characters are not allowed",
        },
        CardExp: {
          required: "Expiration date is required",
          expiryDate: 'Invalid expiration date.'
        },
        // CardCVV: {
        //   required: "Card CVV is required",
        //   allowDigitsAndSteric: "Alphabetic characters are not allowed",
        //   minLength: "Minimum of 3 digits are required",
        // },
      };
      const errorField = this.$v.paymentForm.PaymentCard[fieldName];
      if (!errorField.$dirty) return null;
      const errors = [];
      Object.keys(errorField.$params).forEach((param) => {
        if (!errorField[param]) {
          errors.push(errorMessages[fieldName][param]);
        }
      });
      return errors.length ? errors[0] : null;
    },
    getErrorCardNumberCvv(field) {
      if (!this.isFormSubmitted) {
        return null; // Do not show errors if the form hasn't been submitted
      }
      const cardLength = this.paymentForm.PaymentCard.CardNumber?.length;
      const validCvvLength = cardLength === 15 ? 4 : 3;

      if (!field) {
        return `CVV is required`;
      }
      if (field.length !== validCvvLength) {
        return `CVV must be ${validCvvLength} digits long`;
      }
      if (!this.$v.paymentForm.PaymentCard.CardCVV.allowDigitsAndSteric) {
        return "Only numeric digits are allowed";
      }

      return null;
    },
    getNameAndPrice(id) {
      this.exmaData = this.ExamTypeList.find((item) => item.id === id);
    },
    close() {
      this.$emit("close");
    },
    async Submit() {
      
      this.$v.paymentForm.Exam.$touch();
      if (this.$v.paymentForm.Exam.$invalid) {
        return;
      }
      this.paymentForm.UserId = this.GetPreviewUser.Id;
      this.paymentForm.PaymentCard.UserId = this.GetPreviewUser.Id;
      this.paymentForm.PaidAmount = this.exmaData.price;
      let obj = {};
      if (this.PaymentOption === "offline") {
        this.paymentForm.IsOnlinePayment = false;
          obj.Exam = this.paymentForm.Exam
          obj.IsOnlinePayment = this.paymentForm.IsOnlinePayment
          obj.PaidAmount = this.paymentForm.PaidAmount
          obj.UserId = this.GetPreviewUser.Id
          obj.PaymentCard.UserId = this.GetPreviewUser.Id
      }
      if (this.PaymentOption === "online") {
        this.isFormSubmitted = true;
        // this.$v.paymentForm.BillingDetails.$touch();
        this.$v.paymentForm.PaymentCard.$touch();
        
        if (
          // this.$v.paymentForm.BillingDetails.$invalid ||
          this.$v.paymentForm.PaymentCard.$invalid
        ) {
          return;
        }
        // if (this.paymentForm.PaymentCard.CardNumber.length == 15) {
        //   this.paymentForm.PaymentCard.CardNumber =
        //     this.paymentForm.PaymentCard.CardNumber + "1";
        // }
      }
      this.btnloader = true;
      this.$store
        .dispatch("PayUserExams", this.PaymentOption === "online" ? this.paymentForm : obj)
        .then(() => {
          this.btnloader = false;
          const userId = this.GetPreviewUser.Id;
          this.$store.dispatch("GetUserPurchaseAndBillings", { id: userId });
          this.OfflineSuccessfullDialog = true;
        })
        .catch(() => {
          this.btnloader = false;
          this.$swal.fire({
            toast: true,
            position: "top-end",
            icon: "error",
            title: "Something went wrong",
            showConfirmButton: false,
            timer: 3000,
          });
          this.close();
        });
    },
    closeOfflineSuccessfullDialog() {
      this.OfflineSuccessfullDialog = false;
      this.close();
    },
    GoToStepTwo() {
      this.$v.paymentForm.Exam.$touch();
      if (this.$v.paymentForm.Exam.$invalid) {
        return;
      }
      this.stepOne = false;
      this.stepTwo = true;
    },
    GoBack() {
      this.stepTwo = false;
      this.stepOne = true;
    },
  },
};
</script>

<style scoped>
.h1 {
  font-size: 26px;
  font-weight: 700;
}
.h2 {
  font-size: 22px;
  font-weight: 700;
}
.font-18 {
  font-size: 18px;
}
table,
td,
th {
  border: 1px solid;
}
th {
  background-color: #cccccc;
}
.divider {
  border-color: #e6e6e6;
}
</style>
